<div #plotly_container style="height:100%;">
  <plotly-plot #plot
               [data]="data"
               [layout]="layout"
               [config]="config"
               [useResizeHandler]="true" [style]="{position: 'relative', width: '100%', height: '100%'}">

  </plotly-plot>
</div>
